<app-header class="seed-request-banner" bannerImage="just-seeds.webp"></app-header>

<h1 i18n="@@DesignRequest">Seed Treatment Design Request</h1>
<p i18n="@@SeedPara1">
  This facility is primarily intended for our seed companies partners
</p>
<p i18n="@@SeedPara2">
  Many of the nutritional and biostimulant products that Yara manufactures can be adapted to be used as a seed coating.
   Our chemists have much experience in designing seed treatments and evaluating performance. 
</p>
<p i18n="@@SeedPara3">
  We offer a special service to representatives of seed companies, and growers who undertake 
  large-scale seed treatment. You may specify a desired nutrient application, 
  and give us details of the seeds and other products in the potential coating. 
  Our chemists will then conduct an experimental trial which will confirm an optimal formulation 
  to achieve desired nutritional performance, chemical compatibility and ease of manufacture/application. 
</p>
<p i18n="@@SeedPara4">
  In some cases, seed companies will want to apply multiple products within a single seed treatment.
   Therefore, our chemists will analyse the entire treatment mix to ensure that there are no adverse 
   chemical interactions, including ingredients that may be supplied by a third party. 
</p>

<p i18n="@@SeedPara5">
  All such product development work is naturally commercially sensitive,
   and it is normal to consent to a non-disclosure agreement so that our partners 
   can be assured their product development activities are kept private.
</p>
<div class="alert alert-warning">
  <p>
    <strong i18n="@@Reasonable">Reasonable Request:</strong>
  </p>
  <p i18n="@@SeedPara6">
    We do not charge any fees for the tankmix laboratory analysis. The service is free of charge. 
    We expect that at least one YaraVita product is included in the mix; if no YaraVita product is 
    included, your request may be rejected.
  </p>
</div>
<form [formGroup]="seedCoatingRequestForm">
  <div class="sideBySide">
    <div>
      <div class="form-group">
        <label for="nameTextBox" i18n="@@Name">Name</label>
        <input
          type="text"
          id="nameTextBox"
          name="nameTextBox"
          formControlName="name"
          autocomplete="family-name"
        />
        <div
          *ngIf="name.errors?.['required'] && name.touched"
          class="text-danger"
        >
          *
        </div>
        <small class="form-text textmuted"></small>
      </div>
      <div class="form-group">
        <label for="emailTextBox" i18n="@@Email">Email</label>
        <input
          type="email"
          id="emailTextBox"
          name="emailTextBox"
          formControlName="email"
        />
        <div
          *ngIf="email.errors?.['required'] && email.touched"
          class="text-danger"
        >
          *
        </div>
        <div
          *ngIf="email.errors?.['email'] && email.touched"
          class="text-danger" 
        >
         *
        </div>
        <small class="form-text textmuted"></small>
      </div>
      <div class="form-group">
        <label for="companyTextBox" i18n="@@Company">Company</label>
        <input
          type="text"
          id="companyTextBox"
          name="companyTextBox"
          formControlName="company"
        />

        <small class="form-text textmuted"></small>
      </div>
    </div>

    <div>
      <div class="form-group">
        <label for="requestDateTextBox" i18n="@@Request">Request Date</label>
        <input
          type="date"
          id="requestDateTextBox"
          name="requestDateTextBox"
          formControlName="requestDate"
        />
        <div
          *ngIf="requestDate.errors?.['required'] && requestDate.touched"
          class="text-danger"
        >
          *
        </div>
        <small class="form-text textmuted"></small>
      </div>
      <div class="form-group">
        <label for="countryDropDown" i18n="@@Country">Country</label>
        <select
          id="countryDropDown"
          name="countryDropDown"
          formControlName="country"
          (change)="countryChanged()"
        >
          <option [value]="" [ngValue]="null" disabled>
            --
          </option>
          <option
            *ngFor="let choice of countryChoices"
           
            [value]="choice.code"
          >
            {{ choice.name }}
          </option>
        </select>
      </div>
       <!-- [value]="choice.code + ' - ' + choice.name" -->
      <div class="form-group">
        <label for="requestDateTextBox" i18n="@@NonDisclosure"
          >Non Disclosure Agreement Reference</label
        >
        <input type="text" id="ndaRef" name="ndaRef" formControlName="ndaRef" />

        <small class="form-text textmuted"></small>
      </div>
    </div>
  </div>
  <div class="form-group">
    <label for="seedName" i18n="@@SeedCrop">Seed Crop</label>
    <input
      type="text"
      id="seedName"
      name="seedName"
      formControlName="seedName"
    />
  </div>

  <div class="form-group">
    <label for="commentsTextArea" i18n="@@Comments">Comments</label>
    <textarea
      type="text"
      id="commentsTextArea"
      name="commentsTextArea"
      rows="3"
      formControlName="comments"
    ></textarea>
    <small class="form-text textmuted"></small>
  </div>

  <div class="request-ingredient-table">
    <div class="header">
      <span i18n="@@OrderAddition">Order of Addition</span>
      <span i18n="@@ProductAgro">Yara Product or Agrochemical</span>
      <span i18n="@@DesireAmount">Desired Amount</span>
      <span i18n="@@Units">Units</span>
      <span></span>
    </div>
    <div></div>
    <ng-container
      *ngFor="let ingredient of ingredients.controls; let i = index"
    >
      <div class="ingredientRow" [formGroup]="ingredient">
        <span  class="order-of-addition" > {{ i + 1 }}</span>
        <span>
           <input
            type="text"
            name="ingredientname"
            formControlName="name"
            placeholder="Yara Product or Agrochemical"
            i18n-placeholder="@@ProductAgro"
          /> 
          <!--
          <app-nameid-typeahead
          [items]="yaraProductChoices"
          id="yaraProductCode"
          formControlName="name" class="form-control"
        ></app-nameid-typeahead> -->
        </span>

        <span>
          <input
            type="number"
            name="applicationRate"
            min="0"
            oninput="validity.valid||(value='');"
            formControlName="applicationRate"
            placeholder=""
          
          />
        </span>
        <span>
          <select
       
            formControlName="applicationUnit"
            name="applicationUnit"
          >
            <option value="">--</option>
          <option *ngFor="let choice of applicationUnitChoices">
              {{ choice }}
            </option>
          </select>
        </span>
        <span>
          <button
            *ngIf="i > 0"
            class="btn-danger"
            (click)="deleteProduct(i)"
            i18n="@@Delete"
          >
            Delete
          </button>
        </span>
      </div>
    </ng-container>
  </div>

 
  <p class="aside" i18n="@@SeedPara7">
    Please Note: Instead of a specifying a Yara Product, you can also either 
    specify a list of wanted nutrients, and our micronutrient agronomists 
    will select appropriate product(s) for you.
  </p>
  <button
    id="addIngredient"
    class="btn"
    (click)="addProduct()"
    i18n="@@AddIngredient"
  >
    Add Ingredient
  </button>
</form>
<br />
<app-empty-ingredient *ngIf="invalidIngredients"></app-empty-ingredient>
<button [hidden]="!seedCoatingRequestForm.valid"
  id="submit"
  class="btn-success"
  (click)="submitRequest()"
  i18n="@@Submit"
  [disabled]="seedCoatingRequestForm.invalid"
>
  Submit
</button>

<div id="formedEmail" class="never-displayed">
  <h1 i18n="@@Details">Details</h1>
  <table>
    <tr>
      <th i18n="@@Name">Name</th>
      <td>{{ formValues.name }}</td>
    </tr>
    <tr>
      <th i18n="@@Email">Email</th>
      <td>{{ formValues.email }}</td>
    </tr>
    <tr>
      <th i18n="@@Company">Company</th>
      <td>{{ formValues.company }}</td>
    </tr>
    <tr>
      <th i18n="@@RequestDate">Request Date</th>
      <td>{{ formValues.requestDate }}</td>
    </tr>
    <tr>
      <th i18n="@@Country">Country</th>
      <td>{{ formValues.country }}</td>
    </tr>
    <tr>
      <th i18n="@@WaterRate">Water Rate</th>
      <td>{{ formValues.waterRate }}</td>
    </tr>
    <tr>
      <th i18n="@@Comments">Comments</th>
      <td>{{ formValues.comments }}</td>
    </tr>
    <tr></tr>
  </table>

  <h2 i18n="@@Composition">Composition</h2>

  <table class="">
    <thead></thead>
    <tr>
      <th i18n="@@OrderAddition">Order Of Addition</th>
      <th i18n="@@ProductAgro">YaraVita&trade; Product or agrochemical</th>
      <th i18n="@@ApplicationRate">Application Rate</th>
      <th i18n="@@Units">Units</th>
    </tr>
    <tbody></tbody>
  </table>
</div>
